/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import axios from 'axios';
import { hotjar } from 'react-hotjar';
import { apiBaseUrl, hjId, hjSv } from 'config';
import { isFunctionalCookiesAllowed } from './oneTrustCookiePro';

// axios
const requestInterceptor = (req: any) => req;

const responseInterceptor = (res: any) => res;

export const init = () => {
  axios.defaults.baseURL = apiBaseUrl;
  axios.defaults.headers['Content-Type'] = 'application/json';
  axios.interceptors.request.use(requestInterceptor);
  axios.interceptors.response.use(responseInterceptor);
};

export const initHotJar = () => {
  if (hjId && hjSv && isFunctionalCookiesAllowed()) {
    hotjar.initialize(hjId as any, hjSv as any);
  }
};
